export default {
      id: "JPY-usage",
      viewBox: "0 0 299.5 386.5",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#JPY",
      toString: function () {
        return this.url;
      }
    }